import React from "react";

function SvgImg(props) {
  let blur = "";
  if (props.activeMove) {
    blur = 40;
  }
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 200 146.667"
      height={props.width}
      width={props.height}
    >
      <g id="graphics-editor" transform="translate(0 -68.267)">
        <g
          id="Group_6665"
          data-name="Group 6665"
          transform="translate(0 68.267)"
        >
          <path
            id="Path_16498"
            data-name="Path 16498"
            d="M10,68.267a10,10,0,0,0-10,10V81.6H13.333V68.267Z"
            transform="translate(0 -68.267)"
            fill="#e4eaf6"
          />
          <path
            id="Path_16499"
            data-name="Path 16499"
            d="M491.2,78.267a10,10,0,0,0-10-10h-3.333V81.6H491.2Z"
            transform="translate(-291.2 -68.267)"
            fill="#e4eaf6"
          />
          <rect
            id="Rectangle_7770"
            data-name="Rectangle 7770"
            width="13.333"
            height="13.333"
            transform="translate(13.333 13.333)"
            fill="#e4eaf6"
          />
          <rect
            id="Rectangle_7771"
            data-name="Rectangle 7771"
            width="13.333"
            height="13.333"
            transform="translate(26.667 0)"
            fill="#e4eaf6"
          />
          <rect
            id="Rectangle_7772"
            data-name="Rectangle 7772"
            width="13.333"
            height="13.333"
            transform="translate(40 13.333)"
            fill="#e4eaf6"
          />
          <rect
            id="Rectangle_7773"
            data-name="Rectangle 7773"
            width="13.333"
            height="13.333"
            transform="translate(53.333 0)"
            fill="#e4eaf6"
          />
          <rect
            id="Rectangle_7774"
            data-name="Rectangle 7774"
            width="13.333"
            height="13.333"
            transform="translate(66.667 13.333)"
            fill="#e4eaf6"
          />
          <rect
            id="Rectangle_7775"
            data-name="Rectangle 7775"
            width="13.333"
            height="13.333"
            transform="translate(80 0)"
            fill="#e4eaf6"
          />
          <rect
            id="Rectangle_7776"
            data-name="Rectangle 7776"
            width="13.333"
            height="13.333"
            transform="translate(93.333 13.333)"
            fill="#e4eaf6"
          />
          <rect
            id="Rectangle_7777"
            data-name="Rectangle 7777"
            width="13.333"
            height="13.333"
            transform="translate(106.667 0)"
            fill="#e4eaf6"
          />
          <rect
            id="Rectangle_7778"
            data-name="Rectangle 7778"
            width="13.333"
            height="13.333"
            transform="translate(120 13.333)"
            fill="#e4eaf6"
          />
          <rect
            id="Rectangle_7779"
            data-name="Rectangle 7779"
            width="13.333"
            height="13.333"
            transform="translate(133.333 0)"
            fill="#e4eaf6"
          />
          <rect
            id="Rectangle_7780"
            data-name="Rectangle 7780"
            width="13.333"
            height="13.333"
            transform="translate(146.667 13.333)"
            fill="#e4eaf6"
          />
          <rect
            id="Rectangle_7781"
            data-name="Rectangle 7781"
            width="13.333"
            height="13.333"
            transform="translate(160 0)"
            fill="#e4eaf6"
          />
          <rect
            id="Rectangle_7782"
            data-name="Rectangle 7782"
            width="13.333"
            height="13.333"
            transform="translate(173.333 13.333)"
            fill="#e4eaf6"
          />
          <rect
            id="Rectangle_7783"
            data-name="Rectangle 7783"
            width="13.333"
            height="13.333"
            transform="translate(0 53.333)"
            fill="#e4eaf6"
          />
          <rect
            id="Rectangle_7784"
            data-name="Rectangle 7784"
            width="13.333"
            height="13.333"
            transform="translate(13.333 66.666)"
            fill="#e4eaf6"
          />
          <rect
            id="Rectangle_7785"
            data-name="Rectangle 7785"
            width="13.333"
            height="13.333"
            transform="translate(26.667 53.333)"
            fill="#e4eaf6"
          />
          <path
            id="Path_16500"
            data-name="Path 16500"
            d="M102.4,245.6l3.905-3.905a13.3,13.3,0,0,1,4.025-2.761H102.4Z"
            transform="translate(-62.4 -172.266)"
            fill="#e4eaf6"
          />
          <path
            id="Path_16501"
            data-name="Path 16501"
            d="M149.867,204.8H136.534v12.189a13.343,13.343,0,0,1,5.4,1.144h7.93Z"
            transform="translate(-83.2 -151.467)"
            fill="#e4eaf6"
          />
          <path
            id="Path_16502"
            data-name="Path 16502"
            d="M184,238.933H170.667V245.6l6.666,6.667H184Z"
            transform="translate(-104 -172.266)"
            fill="#e4eaf6"
          />
          <path
            id="Path_16503"
            data-name="Path 16503"
            d="M209.319,204.8H204.8v13.333h13.333v-10A13.281,13.281,0,0,1,209.319,204.8Z"
            transform="translate(-124.8 -151.467)"
            fill="#e4eaf6"
          />
          <path
            id="Path_16504"
            data-name="Path 16504"
            d="M238.933,238.933v13.334h10l3.334-3.334v-10Z"
            transform="translate(-145.6 -172.266)"
            fill="#e4eaf6"
          />
          <path
            id="Path_16505"
            data-name="Path 16505"
            d="M273.067,204.8v13.333h10L286.4,214.8v-10Z"
            transform="translate(-166.4 -151.467)"
            fill="#e4eaf6"
          />
          <path
            id="Path_16506"
            data-name="Path 16506"
            d="M428.133,214.8v-10h-10Z"
            transform="translate(-254.8 -151.467)"
            fill="#e4eaf6"
          />
          <rect
            id="Rectangle_7786"
            data-name="Rectangle 7786"
            width="13.333"
            height="13.333"
            transform="translate(186.667 53.333)"
            fill="#e4eaf6"
          />
          <path
            id="Path_16507"
            data-name="Path 16507"
            d="M462.267,248.933v-10h-10Z"
            transform="translate(-275.6 -172.266)"
            fill="#e4eaf6"
          />
          <rect
            id="Rectangle_7787"
            data-name="Rectangle 7787"
            width="13.333"
            height="13.333"
            transform="translate(0 80)"
            fill="#e4eaf6"
          />
          <path
            id="Path_16508"
            data-name="Path 16508"
            d="M34.133,307.2v6.667L40.8,307.2Z"
            transform="translate(-20.8 -213.867)"
            fill="#e4eaf6"
          />
          <path
            id="Path_16509"
            data-name="Path 16509"
            d="M68.267,279.733l6.666-6.666H68.267Z"
            transform="translate(-41.6 -193.067)"
            fill="#e4eaf6"
          />
          <path
            id="Path_16510"
            data-name="Path 16510"
            d="M204.8,273.067v6.666l6.667,6.667H214.8l3.333-3.333v-10Z"
            transform="translate(-124.8 -193.067)"
            fill="#e4eaf6"
          />
          <rect
            id="Rectangle_7788"
            data-name="Rectangle 7788"
            width="13.333"
            height="13.333"
            transform="translate(0 26.666)"
            fill="#e4eaf6"
          />
          <rect
            id="Rectangle_7789"
            data-name="Rectangle 7789"
            width="13.333"
            height="13.333"
            transform="translate(13.333 40)"
            fill="#e4eaf6"
          />
          <rect
            id="Rectangle_7790"
            data-name="Rectangle 7790"
            width="13.333"
            height="13.333"
            transform="translate(26.667 26.666)"
            fill="#e4eaf6"
          />
          <rect
            id="Rectangle_7791"
            data-name="Rectangle 7791"
            width="13.333"
            height="13.333"
            transform="translate(40 40)"
            fill="#e4eaf6"
          />
          <rect
            id="Rectangle_7792"
            data-name="Rectangle 7792"
            width="13.333"
            height="13.333"
            transform="translate(53.333 26.666)"
            fill="#e4eaf6"
          />
          <path
            id="Path_16511"
            data-name="Path 16511"
            d="M184,174v-3.333H170.667V184H184Z"
            transform="translate(-104 -130.667)"
            fill="#e4eaf6"
          />
          <path
            id="Path_16512"
            data-name="Path 16512"
            d="M205.22,149.867a13.339,13.339,0,0,1,12.913-10v-3.333H204.8v13.333Z"
            transform="translate(-124.8 -109.867)"
            fill="#e4eaf6"
          />
          <path
            id="Path_16513"
            data-name="Path 16513"
            d="M261.5,189.2h4.519v-10A13.3,13.3,0,0,1,261.5,189.2Z"
            transform="translate(-159.351 -135.867)"
            fill="#e4eaf6"
          />
          <path
            id="Path_16514"
            data-name="Path 16514"
            d="M272.412,170.667h-.42a13.356,13.356,0,0,1,.42,3.333Z"
            transform="translate(-165.745 -130.667)"
            fill="#e4eaf6"
          />
          <rect
            id="Rectangle_7793"
            data-name="Rectangle 7793"
            width="13.333"
            height="13.333"
            transform="translate(106.667 26.666)"
            fill="#e4eaf6"
          />
          <path
            id="Path_16515"
            data-name="Path 16515"
            d="M307.2,170.667V184h10l3.333-3.333v-10Z"
            transform="translate(-187.2 -130.667)"
            fill="#e4eaf6"
          />
          <rect
            id="Rectangle_7794"
            data-name="Rectangle 7794"
            width="13.333"
            height="13.333"
            transform="translate(133.333 26.666)"
            fill="#e4eaf6"
          />
          <path
            id="Path_16516"
            data-name="Path 16516"
            d="M375.467,170.667v2.189a13.289,13.289,0,0,1,9.428,3.905l3.905,3.905v-10Z"
            transform="translate(-228.8 -130.667)"
            fill="#e4eaf6"
          />
          <rect
            id="Rectangle_7795"
            data-name="Rectangle 7795"
            width="13.333"
            height="13.333"
            transform="translate(160 26.666)"
            fill="#e4eaf6"
          />
          <rect
            id="Rectangle_7796"
            data-name="Rectangle 7796"
            width="13.333"
            height="13.333"
            transform="translate(186.667 26.666)"
            fill="#e4eaf6"
          />
          <rect
            id="Rectangle_7797"
            data-name="Rectangle 7797"
            width="13.333"
            height="13.333"
            transform="translate(173.333 40)"
            fill="#e4eaf6"
          />
        </g>
        <path
          id="Path_16517"
          data-name="Path 16517"
          d="M209.319,168.4a13.349,13.349,0,1,0-4.519-10A13.278,13.278,0,0,0,209.319,168.4Z"
          transform="translate(-124.8 -46.8)"
          fill="#ffdc69"
        />
        <path
          id="Path_16518"
          data-name="Path 16518"
          d="M311.133,197.415l-10-10-3.333-3.333-3.905-3.905a13.332,13.332,0,0,0-18.855,0l-3.905,3.905-3.334,3.333-10,10-3.333,3.333-10,10-3.333,3.333-10,10-3.334,3.334-1.667,1.667L277.8,280.748h50a10,10,0,0,0,10-10V224.082l-13.333-13.333-10-10Z"
          transform="translate(-137.8 -65.815)"
          fill="#b4ebbe"
        />
        <path
          id="Path_16519"
          data-name="Path 16519"
          d="M88.333,265.482l-1.667-1.667L80,257.149l-6.667-6.667-6.666-6.666-3.905-3.905a13.333,13.333,0,0,0-18.855,0L40,243.816l-6.667,6.667-6.667,6.667L20,263.816l-6.667,6.667L0,283.816v23.333a10,10,0,0,0,10,10H140Z"
          transform="translate(0 -102.215)"
          fill="#a0d778"
        />
      </g>
    </svg>
  );
}
export default React.memo(SvgImg);
